import React, { useState } from "react";
import classes from "./index.module.scss";
import { Input } from "antd";
import classNames from "classnames";

interface InputSearchProps {
    className?: string;
    onChange: (text: string) => void;
    placeholder: string;
}

export default function InputSearch({
    className,
    onChange,
    placeholder
}: InputSearchProps) {
    const [text, setText] = useState("");

    function confirmChange() {
        onChange(text.trim());
    }

    return (
        <div className={classNames(classes.root, className)}>
            <Input
                className={classes.input}
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder={placeholder}
                onPressEnter={confirmChange}
                onBlur={confirmChange}
            />
        </div>
    );
}
